<template>
  <div class="container-fluid permissions-page">
    <PageHeader showBreadcrumbs page-title="Permission table" />
    <div v-if="isLoading" class="content-loading-wrapper" style="min-height: 60vh;">
      <Preloader class="centered-preloader large-spinner" />
    </div>
    <TableForPage
      v-else-if="tableItems.length"
      style="margin-bottom: 0;  overflow: auto;"
      :isLoading="isLoading"
      :tableData="tableItems"
      :fields="headerFields"
      :cellFixed="false"
    />
  </div>
</template>

<script>
import TableForPage from '@tables/TableForPage'
import PageHeader from '@components/PageHeader.vue'
import Preloader from '@components/Preloader'

export default {
  name: 'Permission',
  components: {
    TableForPage,
    PageHeader,
    Preloader
  },
  data () {
    return {
      isLoading: false,
      permission: {

      },
      permissions_map: {
        c: 'create',
        cown: 'create_own',
        uall: 'update_all',
        uown: 'update_own',
        rall: 'read_all',
        rown: 'read_own',
        d: 'delete',
        down: 'delete_own'
      }
    }
  },
  computed: {
    headerFields () {
      let entities = Object.keys(this.permission.administrator)
      entities.unshift('Role name')
      return entities
    },
    tableItems () {
      const rolesKeys = Object.keys(this.permission)
      const entitiesesKeys = Object.keys(this.permission.administrator)
      const permissionsMapKeys = Object.keys(this.permissions_map)
      let tableItemsArr = []
      rolesKeys.map(role => {
        let item = {
          'Role name': role.replace('_', ' ')
        }
        entitiesesKeys.map(entities => {
          item[entities] = []
          if (this.permission[role][entities]) {
            this.permission[role][entities].map(elem => {
              permissionsMapKeys.map(perm => {
                if (perm === elem) {
                  item[entities].push(this.permissions_map[perm])
                }
              })
            })
          }
          item[entities] = item[entities].join(', \n')
        })
        tableItemsArr.push(item)
      })
      return tableItemsArr
    }
  },
  async mounted () {
    try {
      this.isLoading = true
      await this.$api.permission.getAllPermission()
      this.permission = { ...this.$store.getters.getAllPermission.permission }
    } catch (e) {
      throw (e)
    } finally {
      this.isLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.permissions-page {
  .b-table-sticky-header {
    max-height: calc(100vh - 200px)
  }

  tbody {
    tr {
      td:nth-child(1) {
        &::first-letter {
          text-transform: uppercase
        }

        font-weight: 600;
      }
    }
  }
}
</style>
